module.exports = __webpack_public_path__ + "img/1.8d16edb8.jpg";